import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { checkUrl } from '../deployment'

@Injectable({
  providedIn: 'root'
})
export class HomePageService {
    constructor(private http: HttpClient, private router: Router) { }


/*Query form API  (Requirment fullName*,email* , phoneNumber*, subject*, message *, Attach (For attach file)
*/
queryForm($data: any) {
    return this.http.post(checkUrl()+"/user/query",$data)
    .pipe((response)=>{
        return response;
    })
}

homepageContent(){
    return this.http.get(checkUrl()+"/homepage/list")
    .pipe((response)=>{
          return response;
    })
}


//requirment (fullName *,email *, serviceName *,serviceId *)
userAppointment($data:any) {
    return this.http.post(checkUrl()+"/user/appointment",$data)
    .pipe((response)=>{
          return response;
    })
}

subjectsList() {
  return this.http.get(checkUrl()+"/subject/list")
    .pipe((response)=>{
          return response;
    })
}

servicesList() {
  return this.http.get(checkUrl()+"/services/list")
    .pipe((response)=>{
          return response;
    })
}

termConditionAndPrivacyPolicy(){
    return this.http.get(checkUrl()+"/homepage/term-privacy")
    .pipe((response)=>{
          return response;
    })
}

getPayment($data) {
  return this.http.post(checkUrl() + "/user/payment", $data)
  .pipe((response)=>{
    return response;
  })
}

}
